import { Tooltip, TooltipProps, styled, tooltipClasses } from "@mui/material";
import React from "react";

interface EnhancedTooltipProps {
  header?: string;
  content: React.ReactNode;
  children: React.ReactElement;
  placement?: TooltipProps["placement"];
  arrow?: boolean;
  open?: boolean;
  onClose?: TooltipProps["onClose"];
  onOpen?: TooltipProps["onOpen"];
  className?: string;
  PopperProps?: TooltipProps["PopperProps"];
  fullWidth?: boolean;
  indicator?: unknown;
  selectionFollowsFocus?: boolean;
  textColor?: string;
}

export const EnhancedTooltip = styled(({ className, header, content, children, ...props }: EnhancedTooltipProps) => {
  const tooltipProps = { ...props };

  delete tooltipProps.fullWidth;
  delete tooltipProps.indicator;
  delete tooltipProps.selectionFollowsFocus;
  delete tooltipProps.textColor;

  return (
    <Tooltip
      {...tooltipProps}
      title={
        header ? (
          <div>
            <div className="EnhancedTooltip-header" style={{ fontWeight: 600, marginBottom: "4px" }}>
              {header}
            </div>
            <div>{content}</div>
          </div>
        ) : (
          content
        )
      }
      arrow
      classes={{ popper: className }}
    >
      {children}
    </Tooltip>
  );
})(({ theme }) => ({
  [`& .${tooltipClasses.arrow}`]: {
    color: theme.semanticColors.background.tooltip,
    "&::before": {
      backgroundColor: theme.semanticColors.background.tooltip,
    },
  },
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.semanticColors.background.tooltip,
    fontSize: "12px",
    color: theme.semanticColors.text.tooltip,
    boxShadow: "none",
    borderRadius: "8px",
    lineHeight: "18px",
    padding: "12px",
  },
  [`& .EnhancedTooltip-header`]: {
    color: theme.semanticColors.text.inverse,
  },
}));
